import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveOptimizedGanttRequestFailure(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.request.isFailure : false;
    },
    isRetrieveOptimizedGanttRequestPending(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.request.isPending : false;
    },
    isRetrieveOptimizedGanttRequestSuccess(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.request.isSuccessful : false;
    },
    getOptimizedGantt(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.gantt : [];
    },
    getOptimizedGanttPage(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.currentPage : 0;
    },
    canRetrieveOptimizedGantt(filter, sort, size) {
      const state = getState();
      const index = matchRequest(state, filter, sort, size);
      const req = state[index];

      return req ? req.canLoadMore : true;
    },
  };
}

export { createSelector };
